function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "download"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m21 14c-.553 0-1 .447-1 1v2c0 .552-.448 1-1 1h-14c-.552 0-1-.448-1-1v-2c0-.553-.447-1-1-1s-1 .447-1 1v2c0 1.654 1.346 3 3 3h14c1.654 0 3-1.346 3-3v-2c0-.553-.447-1-1-1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m11.293 15.707c.195.195.451.293.707.293s.512-.098.707-.293l5-5c.286-.286.372-.716.217-1.09-.154-.374-.52-.617-.924-.617h-2v-2c0-1.654-1.346-3-3-3s-3 1.346-3 3v2h-2c-.404 0-.77.243-.924.617-.155.374-.069.804.217 1.09zm-.293-8.707c0-.552.448-1 1-1s1 .448 1 1v3c0 .553.447 1 1 1h.586l-2.586 2.586-2.586-2.586h.586c.553 0 1-.447 1-1z"
})));

var Svg041Download = function Svg041Download(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg041Download, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/041-download.e0ced7ab.svg";
export { ForwardRef as ReactComponent };